import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from './users.component';
import { UserModule } from './user/user.module';
import {
  NbInputModule,
  NbCardModule,
  NbSpinnerModule,
  NbPopoverModule,
  NbSelectModule,
  NbIconModule, NbButtonModule, NbDatepickerModule, NbToggleModule
} from '@nebular/theme';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPaginationModule} from "ngx-pagination";
import {UserDetailsDialogComponent} from "./user-details-dialog/user-details-dialog.component";
import { NbDateFnsDateModule } from '@nebular/date-fns';

@NgModule({
  declarations: [UsersComponent,UserDetailsDialogComponent],
  imports: [
    CommonModule,
    NbCardModule,
    UserModule,
    NbSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    NbInputModule,
    NbPopoverModule,
    NbSelectModule,
    NgxPaginationModule,
    NbIconModule,
    NbButtonModule,
    NbDatepickerModule.forRoot(),
    NbToggleModule,
    NbDateFnsDateModule.forRoot({ format: 'yyyy-MM-dd' }),
  ],
})
export class UsersModule { }
